import {
  CategoryResponse,
  EventResponse,
  ExtendedEvent,
} from '../../constants/types'
import { getLanguageByCode } from './getLanguages'
import { getParsedDate, getParsedTime } from './parseDateTime'

export const getExtendedEvent = (
  event: EventResponse,
  categories: CategoryResponse[] = []
) => {
  const category = categories?.find((cat) => cat.id === event.categoryId)
  const eventExtention = {
    parsedTime: getParsedTime(event.time),
    parsedDate: getParsedDate(event.time),
    categoryName: category ? category.name : 'Unknown Category',
    languageName: getLanguageByCode(event.language?.toLowerCase()).name,
  }
  return { ...event, ...eventExtention } as ExtendedEvent
}
